import ExpandableRowDesktop from './ExpandableRowDesktop';

export default ExpandableRowDesktop;
